document.addEventListener('alpine:init', () => {
  Alpine.data('CommunityMessages', (root) => ({
    active: false, enabled: false, customer: '', inbox: [], nextCursor: null, unread: 0,
    conversation: '', peer: null, messages: [], hasOlder: false, draft: '', pending: null,
    blocked: false, canSend: true, busy: false, loading: false, conversationLoading: false, error: '', notice: '',
    reportMessage: null, reportReason: '', reporting: false, blockConfirm: false,
    timer: null, failures: 0, epoch: 0, refreshing: false, readSeq: '0', destroyed: false,
    welcomeVisitPending: false, welcomeVisits: {}, markingUnread: false, readToken: undefined,
    init() {
      this.enabled = root.dataset.enabled === 'true' || Boolean(window.ModlMessagesPreview);
      if (!this.enabled) return;
      this.$watch('draft', () => this.$nextTick(() => this.resizeComposer()));
      this.onOpen = e => this.open(e.detail || {});
      this.onClose = () => this.close();
      this.onResize = () => { this.fitViewport(); this.resizeComposer(); };
      this.onFocus = () => { this.onResize(); if (!document.hidden) { this.failures = 0; this.refresh(); } };
      this.onHide = () => { if (document.hidden) clearTimeout(this.timer); else this.onFocus(); };
      this.onAuthLost = () => { this.clearPrivate(); this.error = 'Please sign in again to continue.'; this.enabled = false; };
      this.onPageHide = () => { this.clearPrivate(); };
      window.addEventListener('modl-dm-open', this.onOpen);
      window.addEventListener('modl-dm-close', this.onClose);
      window.addEventListener('focus', this.onFocus);
      window.addEventListener('resize', this.onResize);
      window.addEventListener('modl-auth-lost', this.onAuthLost);
      window.addEventListener('pagehide', this.onPageHide);
      window.addEventListener('pageshow', this.onFocus);
      window.addEventListener('modl-profile-created', this.onFocus);
      document.addEventListener('visibilitychange', this.onHide);
      this.refresh();
    },
    destroy() {
      this.destroyed = true; this.clearPrivate();
      window.removeEventListener('modl-dm-open', this.onOpen);
      window.removeEventListener('modl-dm-close', this.onClose);
      window.removeEventListener('focus', this.onFocus);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('modl-auth-lost', this.onAuthLost);
      window.removeEventListener('pagehide', this.onPageHide);
      window.removeEventListener('pageshow', this.onFocus);
      window.removeEventListener('modl-profile-created', this.onFocus);
      document.removeEventListener('visibilitychange', this.onHide);
    },
    clearPrivate() {
      this.welcomeVisitPending = false;
      this.conversationLoading = false;
      this.epoch++; clearTimeout(this.timer); this.inbox = []; this.messages = []; this.peer = null;
      this.draft = ''; this.pending = null; this.conversation = ''; this.customer = ''; this.unread = 0;
      this.reportMessage = null; this.reportReason = ''; this.notice = ''; this.publishCount();
    },
    publishCount() { window.dispatchEvent(new CustomEvent('modl-dm-count', { detail: this.unread })); },
    async api(path, body, identity) {
      const response = await window.ModlCommunityAPI.request('/api/dm' + path, body === undefined ? {} : {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
      }, identity);
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || 'Messages are temporarily unavailable.');
      return data;
    },
    async open(member) {
      if (!this.enabled) return;
      if (!this.active) this.welcomeVisitPending = !member.id;
      if (member.id) this.welcomeVisitPending = false;
      this.returnFocus = document.activeElement;
      this.active = true; this.error = ''; this.notice = '';
      this.$nextTick(() => this.fitViewport(true));
      if (member.id) {
        const existing = this.inbox.find(c => c.peer_id === String(member.id));
        await this.select(existing || { peer_id: String(member.id), peer: member });
      } else if (!this.peer) this.$nextTick(() => this.$refs.heading?.focus({ preventScroll: true }));
      this.refresh();
    },
    close() {
      this.welcomeVisitPending = false;
      this.conversationLoading = false;
      this.active = false; this.epoch++; this.messages = []; this.peer = null; this.conversation = '';
      this.draft = ''; this.pending = null; this.reportMessage = null; this.reportReason = ''; this.blockConfirm = false;
      this.returnFocus?.focus?.({ preventScroll: true });
    },
    async select(item) {
      if (this.markingUnread) return;
      this.readToken = undefined;
      this.welcomeVisitPending = false;
      this.conversationLoading = true;
      this.epoch++; this.conversation = item.id || ''; this.peer = { ...item.peer, id: item.peer_id };
      this.messages = []; this.draft = ''; this.pending = null; this.readSeq = '0'; this.hasOlder = false;
      this.blocked = false; this.canSend = true; this.error = ''; this.notice = ''; this.blockConfirm = false;
      this.reportMessage = null; this.reportReason = '';
      this.$nextTick(() => this.$refs.recipientHeading?.focus({ preventScroll: true }));
      const epoch = this.epoch;
      try {
        const identity = await window.ModlCommunityAPI.session();
        if (epoch !== this.epoch) return;
        this.customer = identity.customer_id;
        if (!this.conversation) {
          const existing = await this.api('/with/' + this.peer.id, undefined, identity);
          if (epoch !== this.epoch) return;
          this.conversation = existing.id || ''; this.peer = existing.peer; this.blocked = existing.blocked_by_me; this.canSend = existing.can_send;
        }
        await this.loadConversation(identity);
      } catch(e) { if (epoch === this.epoch) this.error = e.message; }
      finally { if (epoch === this.epoch) this.conversationLoading = false; }
    },
    back() { this.conversationLoading = false; this.epoch++; this.peer = null; this.conversation = ''; this.messages = []; this.draft = ''; this.pending = null; this.reportMessage = null; this.blockConfirm = false; this.$nextTick(() => this.$refs.heading?.focus({ preventScroll: true })); },
    async openWelcomeOnce() {
      if (!this.active || this.peer || !this.welcomeVisitPending) return false;
      this.welcomeVisitPending = false;
      const key = 'modl-messages-visited:' + this.customer;
      let visited = this.welcomeVisits[key];
      try { visited = visited || window.localStorage.getItem(key) === '1'; } catch {}
      this.welcomeVisits[key] = true;
      try { window.localStorage.setItem(key, '1'); } catch {}
      const welcome = !visited && this.inbox.find(item => item.welcome_unread && item.unread > 0);
      if (!welcome) return false;
      await this.select(welcome);
      return true;
    },
    schedule() {
      clearTimeout(this.timer);
      if (this.enabled && !this.destroyed && !document.hidden) this.timer = setTimeout(() => this.refresh(), Math.min(60000, 10000 * 2 ** this.failures));
    },
    async refresh() {
      if (this.markingUnread || this.refreshing || !this.enabled || this.destroyed || document.hidden) return;
      this.refreshing = true; const epoch = this.epoch;
      try {
        const identity = await window.ModlCommunityAPI.session();
        if (!identity.messages_enabled) { this.clearPrivate(); this.enabled = false; this.error = 'Messages are not enabled yet.'; return; }
        const data = await this.api('/inbox', undefined, identity);
        if (epoch !== this.epoch || this.destroyed) return;
        this.customer = identity.customer_id; this.inbox = data.conversations; this.nextCursor = data.next_cursor;
        this.unread = data.unread; this.publishCount(); this.failures = 0;
        if (await this.openWelcomeOnce()) return;
        if (this.active && this.conversation) await this.loadConversation(identity);
      } catch (e) { this.failures = Math.min(this.failures + 1, 3); if (this.active) this.error = e.name === 'AbortError' ? 'Connection timed out. Try again.' : e.message; }
      finally { this.refreshing = false; this.schedule(); }
    },
    async moreInbox() {
      if (this.nextCursor === null || this.loading) return;
      this.loading = true; const epoch = this.epoch;
      try {
        const data = await this.api('/inbox?cursor=' + encodeURIComponent(this.nextCursor));
        if (epoch !== this.epoch) return;
        const ids = new Set(this.inbox.map(c => c.id));
        this.inbox.push(...data.conversations.filter(c => !ids.has(c.id))); this.nextCursor = data.next_cursor;
      } catch(e) { this.error = e.message; } finally { this.loading = false; }
    },
    async loadConversation(identity, older = false) {
      if (this.markingUnread || !this.conversation || !this.active) return;
      const epoch = this.epoch; const id = this.conversation;
      await this.$nextTick();
      if (epoch !== this.epoch || this.markingUnread) return;
      try {
        const before = older && this.messages[0] ? '?before=' + this.messages[0].seq : this.messages.length ? '?after=' + this.messages[this.messages.length - 1].seq : '';
        const data = await this.api('/conversations/' + id + before, undefined, identity);
        if (epoch !== this.epoch || !this.active || this.destroyed) return;
        // Capture once per visit; background polling must not adopt a newer unread reminder.
        if (this.readToken === undefined) this.readToken = data.read_token ?? null;
        this.peer = { ...data.peer, id: data.peer_id }; this.blocked = data.blocked_by_me; this.canSend = data.can_send;
        // Use the current position: the reader may have scrolled while the request was pending.
        const scroller = this.$refs.history; const oldHeight = scroller?.scrollHeight || 0;
        const atBottom = !scroller || scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight < 90;
        const previous = this.messages;
        const bySeq = new Map([...previous, ...data.messages].map(m => [m.seq, m]));
        const addedMessages = bySeq.size > previous.length;
        if (data.messages.length) this.messages = [...bySeq.values()].sort((a,b) => Number(a.seq) - Number(b.seq));
        if (older || !previous.length) this.hasOlder = data.has_older;
        this.error = '';
        await this.$nextTick();
        if (epoch !== this.epoch || this.markingUnread) return;
        if (addedMessages && scroller) {
          if (older) scroller.scrollTop += scroller.scrollHeight - oldHeight;
          else if (atBottom || !previous.length) scroller.scrollTop = scroller.scrollHeight;
        }
        await this.markRead(identity);
        if (epoch === this.epoch && data.has_newer) await this.loadConversation(identity);
      } catch(e) { if (epoch === this.epoch) this.error = e.message; throw e; }
    },
    async older() { if (this.loading) return; this.loading = true; try { await this.loadConversation(undefined, true); } catch {} finally { this.loading = false; } },
    async markRead(identity) {
      const scroller = this.$refs.history;
      if (this.markingUnread || !this.active || document.hidden || !document.hasFocus() || !this.conversation || !this.messages.length ||
        (scroller && scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight > 90)) return;
      const seq = this.messages[this.messages.length - 1].seq;
      if (Number(seq) <= Number(this.readSeq)) return;
      const epoch = this.epoch;
      const id = this.conversation;
      try {
        const data = await this.api('/conversations/' + id + '/read', { seq, read_token: this.readToken ?? null }, identity);
        if (epoch !== this.epoch) return;
        this.readSeq = seq; this.applyUnreadCounts(id, data);
      } catch {}
    },
    applyUnreadCounts(id, data) {
      if (!Number.isInteger(data.total_unread) || !Number.isInteger(data.unread)) return;
      this.inbox = this.inbox.map(item => item.id === id ? { ...item, unread: data.unread } : item);
      this.unread = data.total_unread; this.publishCount();
    },
    async markUnread() {
      if (this.markingUnread || this.busy || !this.conversation || this.conversationLoading) return;
      const id = this.conversation;
      this.markingUnread = true; this.welcomeVisitPending = false;
      // Invalidate pending history/inbox/read responses before saving the reminder.
      const epoch = ++this.epoch;
      this.error = ''; this.notice = '';
      try {
        const data = await this.api('/conversations/' + id + '/unread', {});
        if (epoch !== this.epoch) return;
        this.back(); this.applyUnreadCounts(id, data);
        this.notice = 'Conversation marked unread.';
      } catch (e) {
        if (epoch === this.epoch) this.error = 'Could not mark unread. ' + e.message;
      } finally { this.markingUnread = false; this.schedule(); }
    },
    fitViewport(reveal = false) {
      if (!this.active || !root.offsetWidth) return;
      // Opening Messages starts at the top on every screen size.
      // Resizing or switching conversations must not move the page.
      if (reveal) window.scrollTo({ top: 0, behavior: 'instant' });
      if (window.innerWidth < 750) return;
      const top = root.getBoundingClientRect().top;
      root.style.setProperty('--modl-dm-height', Math.max(0, window.innerHeight - Math.max(0, top) - 16) + 'px');
    },
    resizeComposer() {
      const input = this.$refs.composer;
      if (!input || !input.offsetWidth) return;
      const history = this.$refs.history;
      const scrollTop = history?.scrollTop;
      input.style.height = '44px';
      input.style.height = Math.min(140, Math.max(44, input.scrollHeight + 2)) + 'px';
      // Measuring the shorter textarea can temporarily clamp the history's scroll position.
      if (history) history.scrollTop = scrollTop;
    },
    async send() {
      if (this.markingUnread || this.busy || !this.peer || !this.canSend || !this.draft.trim()) return;
      if (window.ModlCommunityTerms && !await window.ModlCommunityTerms.ensure()) return;
      if (this.markingUnread || this.busy || !this.peer || !this.canSend || !this.draft.trim()) return;
      this.busy = true; this.error = ''; this.notice = ''; const epoch = this.epoch;
      const text = this.draft;
      if (!this.pending || this.pending.body !== text) this.pending = { body: text, request_id: crypto.randomUUID(), ...(this.conversation ? { conversation_id: this.conversation } : { recipient_id: this.peer.id }) };
      try {
        const data = await this.api('/send', this.pending);
        if (epoch !== this.epoch) return;
        this.conversation = data.conversation_id; this.pending = null; if (this.draft === text) this.draft = '';
        try { await this.loadConversation(); } catch { this.notice = 'Message sent. Reconnecting to update the conversation…'; }
        await this.$nextTick();
        if(this.$refs.history) this.$refs.history.scrollTop = this.$refs.history.scrollHeight;
        this.refresh(); this.markRead(); this.$nextTick(() => this.$refs.composer?.focus({ preventScroll: true }));
      } catch(e) { if (epoch === this.epoch) this.error = 'Not sent yet. ' + e.message + ' Your message is still here to retry.'; }
      finally { this.busy = false; }
    },
    async toggleBlock() {
      const epoch = this.epoch; this.busy = true;
      try {
        const data = await this.api('/block', { customer_id: this.peer.id, blocked: !this.blocked });
        if (epoch !== this.epoch) return;
        this.blocked = data.blocked_by_me; this.canSend = data.can_send; this.blockConfirm = false;
        this.notice = this.blocked ? 'Member blocked. Your conversation history is kept.' : 'Member unblocked.';
      } catch(e) { this.error = e.message; } finally { this.busy = false; }
    },
    async submitReport() {
      if (!this.reportReason.trim() || this.reporting) return;
      this.reporting = true; const epoch = this.epoch;
      try {
        await this.api('/conversations/' + this.conversation + '/report', { seq: this.reportMessage.seq, reason: this.reportReason });
        if (epoch !== this.epoch) return;
        this.reportMessage = null; this.reportReason = ''; this.notice = window.ModlMessagesPreview ? 'Sample report complete. Nothing was submitted to MODL.' : 'Report submitted for review.';
      } catch(e) { this.error = e.message; } finally { this.reporting = false; }
    },
    stamp(value) { return new Date(value).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }); },
    day(value) { return new Date(value).toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' }); },
  }));
});
